import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui'
import stores from '@/vuex/index'
const load = (path) => { // 路由懒加载
    return () => Promise.resolve(require(`@/views/${path}`).default)
}
const $import = (path) => { // 直接加载
    return () => import(`@/views/${path}`)
}

/* 登录页 */
import Login from '@/views/Login.vue'

// const Login = $import('Login.vue');
const Home = load('home/Home.vue');
/**error 401 */
const Page401 = load('errorPage/401.vue');
const Page404 = load('errorPage/404.vue');
/**项目 */
const project = load('project/Project.vue');

/** AddInquiry AddInquiryEng 未用到 包含BMap 先删除 */
const SingleInquiry = load('Inquiry/SingleInquiry.vue');
const InquiryDetail = load('Inquiry/InquiryDetail.vue');
/**工程询价 */
const SingleInquiryEng = load('Inquiry/SingleInquiryEng.vue');
const InquiryDetailEng = load('Inquiry/InquiryDetailEng.vue');
/**权限管理 */
const permissonSetting = load('setting/PermissonSetting.vue');
/**部门管理 */

const departManagement = load('setting/DepartManagement.vue');
/**角色管理 */
const roleManagement = load('setting/RoleManagement.vue');
/**用户管理 */
const userMangement = load('setting/UserMangement.vue');
/**个人中心 */
const personal = load('setting/Personal.vue');

/**日志管理*/
const crudManage = load('setting/crudManage.vue')

/**日志管理*/
const logsInfo = load('setting/crud.vue')

/**配置管理 */
const dictionary = load('config/dictionary.vue');
const freightConfig = load('config/freightConfig.vue');
const freightEdit = load('config/freightEdit.vue');
const freightDetail = load('config/freightDetail.vue');
const notifications = load('config/notifications.vue');
const notificationsEdit = load('config/notificationsEdit.vue');
const notificationsDetail = load('config/notificationsDetail.vue');
const basePriceConfig = load('config/basePrice/manage.vue');
const basePriceView = load('config/basePrice/view.vue');
const basePriceEdit = load('config/basePrice/edit.vue');
const basePriceAdd = load('config/basePrice/add.vue');
const shipperContractPriceConfig = load('config/shipperContractPrice/manage.vue');
const shipperContractPriceView = load('config/shipperContractPrice/view.vue');
const shipperContractPriceEdit = load('config/shipperContractPrice/edit.vue');
const shipperContractPriceAdd = load('config/shipperContractPrice/add.vue');

const fleetContractPriceConfig = load('config/fleetContractPrice/manage.vue');
const fleetContractPriceView = load('config/fleetContractPrice/view.vue');
const fleetContractPriceEdit = load('config/fleetContractPrice/edit.vue');
const fleetContractPriceAdd = load('config/fleetContractPrice/add.vue');
//异常
const errorManager = load('error/errorManager.vue');
/**基础资料 */
/** storeManagement 未用到 包含BMap 先删除 */
const expenseType = load('baseData/expenseType.vue');
const addressBook = load('baseData/addressBook.vue');
const platformManagement = load('baseData/platformManagement.vue');
const timeWindow = load('baseData/timeWindow.vue');
const timeWindowEdit = load('baseData/timeWindowEdit.vue');
const shipManagement = load('baseData/ShipManagement.vue');
const consigneeShipperManagement = load('baseData/ConsigneeShipperManagement.vue');
/**财务 */

const serviceStatement = load('financial/ServiceStatement.vue');
const serviceBillDetails = load('financial/ServiceBillDetails.vue');
const payManagement = load('financial/PayManagement.vue');
const receivableManagement = load('financial/ReceivableManagement.vue');
const payStatement = load('financial/PayStatement.vue');
const paystatementDetails = load('financial/PaystatementDetails.vue');
const receivableStatement = load('financial/ReceivableStatement.vue');
const receivableStatementDetails = load('financial/ReceivableStatementDetails.vue');
/**承运商 */
const carrierManager = load('carrier/carrierManager.vue');
/**发货 */
const addOrder = load('order/addOrder.vue');
const orderManager = load('order/orderManager.vue');
const orderAcceptManager = load('order/orderAcceptManager.vue');
const orderPayManager = load('order/orderPayManager.vue');

const orderAccept = load('order/orderAccept.vue');
const orderpays = load('order/orderpays.vue');
const orderDetail = load('order/orderDetail.vue');
const orderDetailcc = load('order/orderDetailgo.vue');
const orderDetailMore = load('order/orderDetailMore.vue');
const orderDetailEng = load('order/orderDetailEng.vue');
const oneMoreOrderDetail = load('order/oneMoreOrderDetail.vue');

const carrierPortrait = load('carrier/carrierPortrait.vue');
const carrierKPI = load('carrier/carrierKPI.vue');
const carrierKPIDetail = load('carrier/carrierKPIDetail.vue');

/**车辆管理 */
const dirverManager = load('capacity/dirverManager.vue');
const carManager = load('capacity/carManager.vue');
const contractManage = load('contract/contractManager.vue');

/**运单管理 */
const waybillManager = load('deliverGoods/waybillManage/WayBillManage.vue');
const WayBillDetail = load('deliverGoods/waybillManage/WayBillDetail.vue');
const locationDetail = load('deliverGoods/waybillManage/components/Location.vue');
const evaluteDetail = load('deliverGoods/waybillManage/Location.vue');
/**回单管理 */
const receiptManager = load('receiptManage/ReceiptManage.vue');

/**项目 */
/** AddProject 未用到 包含BMap 先删除 */
const ProjectManager = load('project/projectManager.vue');
const ProjectDetail = load('project/projectDetail.vue');

const Dashboard = load('dashboard/Dashboard.vue')

/**预约管理 */
const callBoard = load('appointMent/callBoard.vue');
const callManage = load('appointMent/callManage.vue');
const queueManage = load('appointMent/queueManage.vue');
const analysisManage = load('dataAnalysis/analysisManage.vue');

const Location = load('onlineView/Location.vue');

import NProgress from 'nprogress';
import ShipManagement from '../views/baseData/ShipManagement.vue';

Vue.use(Router);
let constRouters = [
    {
        path: '/',
        hidden: true,
        redirect: {
            name: 'login'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        hidden: true,
        meta: {
            title: '从节点登录'
        },
    },
    {
        path: '/',
        component: Home,
        icon: 'quickStart',
        hidden: true,
        meta: {
            title: '详情页面'
        },
        children:[
            {
                path: '/orderDetailcc',
                name: '发货计划详情',
                hidden: true,
                component: orderDetailcc,
                meta: {
                    title: '订单详情',
                }
            },
            {
                path: '/WayBillDetail',
                name: '运单详情',
                hidden: true,
                component: WayBillDetail,
                meta: {
                    title: '运单详情',
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        icon: 'quickStart',
        hidden: true,
        leaf: true, //只有一个节点
        meta: {
            title: '错误页面'
        },
        children: [
            {
                path: '/401',
                component: Page401,
                name: '401',
                meta: {
                    title: '无权限'
                }
            },         
        ]
    },
];
// 详情路由
let detailRoutes = [ 
    {
        path: '/',
        component: Home,
        hidden: true,
        icon: 'icon-fahuo',
        name: '发货',     
       
    },
   
]
let permissonRoutes = [
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-fahuo',
        name: '发货',
        meta: {
            auth: ['fh1', 'fbfhjh2', 'whyjsh2','cdyjtb2', 'ydgl2','ztjk2'],
        },
        children: [
            {
                path: '/addOrder',
                name: '发布发货计划',
                component: addOrder,
                meta: {
                    title: '发布发货计划',
                    auth: ['fbfhjh2'],
                }
            },
            {
                path: '/orderManager',
                name: '发货计划管理',
                component: orderManager,
                meta: {
                    title: '发货计划管理',
                    auth: ['fhjh2'],
                }
            },
            {
                path: '/orderAcceptManager',
                name: '网货运价审核',
                component: orderAcceptManager,
                meta: {
                    title: '网货运价审核',
                    auth: ['whyjsh2'],
                }
            },
            {
                path: '/orderPayManager',
                name: '车队运价填报',
                component: orderPayManager,
                meta: {
                    title: '车队运价填报',
                    auth: ['cdyjtb2'],
                }
            },
            {
                path: '/orderAccept',
                name: '网络运价审核',
                component: orderAccept,
                hidden: true,
                meta: {
                    title: '网络运价审核',
                }
            },
            {
                path: '/orderpays',
                name: '车队运价填写',
                component: orderpays,
                hidden: true,
                meta: {
                    title: '车队运价填写',
                }
            },
            {
                path: '/orderDetail',
                name: '发货计划详情',
                hidden: true,
                component: orderDetail,
                meta: {
                    title: '订单详情',
                    guidePath: true,
                    jumpPath: '/orderManager'
                }
            },
            {
                path: '/orderDetailcc',
                name: '发货计划详情',
                hidden: true,
                component: orderDetailcc,
                meta: {
                    title: '订单详情',
                    guidePath: true,
                    jumpPath: '/orderManager'

                }
            },
            {
                path: '/orderDetailMore',
                name: '订单并单',
                hidden: true,
                component: orderDetailMore,
                meta: {
                    title: '订单并单',
                    guidePath: true,
                    jumpPath: '/orderManager'
                }
            },
            {
                path: '/orderDetailEng',
                name: '发布运单',
                hidden: true,
                component: orderDetailEng,
                meta: {
                    title: '发布运单',
                    guidePath: true,
                    jumpPath: '/orderManager'
                }
            },
            {
                path: '/oneMoreOrderDetail',
                name: '分单运输',
                hidden: true,
                component: oneMoreOrderDetail,
                meta: {
                    title: '分单运输',
                    guidePath: true,
                    jumpPath: '/orderManager'
                }
            },
            {
                path: '/WayBillManage',
                name: '运单管理',
                hidden: false,
                component: waybillManager,
                meta: {
                    auth: ['ydgl2'],
                    title: '运单管理',
                }
            },
            {
                path: '/WayBillDetail',
                name: '运单详情',
                hidden: true,
                component: WayBillDetail,
                meta: {
                    title: '运单详情',
                    guidePath: true,
                    jumpPath: '/WayBillManage'
                }
            },
            {
                path: '/WayBillLocation',
                name: '定位信息',
                hidden: true,
                component: locationDetail,
                meta: {
                    title: '定位信息'
                }
            },
            {
                path: '/Evaluate',
                name: '评价',
                hidden: true,
                component: evaluteDetail,
                meta: {
                    title: '评价'
                }
            },
            {
                path: '/onLineView',
                name: '在途监控',
                hidden: false,
                component: Location,
                meta: {
                    auth:['ztjk2'],
                    title: '在途监控'
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-yichang',
        name: '异常',
        meta: {
            auth: ['ycgl1', 'ycgl2'],
        },
        children: [
            {
                path: '/errorManager',
                name: '异常管理',
                component: errorManager,
                meta: {
                    auth: ['ycgl2'],
                    title: '异常管理',
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-huidan',
        name: '回单',
        meta: {
            auth: ['hd1', 'hdgl2'],
        },
        children: [
            {
                path: '/receiptManager',
                name: '回单管理',
                hidden: false,
                component: receiptManager,
                meta: {
                    auth: ['hdgl2'],
                    title: '回单管理'
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-caiwu',
        name: '财务',
        meta: {
            auth: ['cw1', 'cwf2', 'cwd2'],
            title: '财务'
        },
        children: [
            {
                path: '/payManagement',
                name: '应付费用',
                component: payManagement,
                meta: {
                    auth: ['yffy2'],
                    title: '应付费用'
                }
            },
            {
                path: '/payStatement',
                name: '应付对账单',
                component: payStatement,
                meta: {
                    auth: ['yfdzd2'],
                    title: '应付对账单'
                }
            },
            {
                path: '/paystatementDetails',
                name: '应付对账单详情',
                component: paystatementDetails,
                hidden: true,
                meta: {
                    title: '应付对账单详情',
                    guidePath: true,
                    jumpPath: '/payStatement'
                }
            },
            {
                path: '/receivableManagement',
                name: '应收费用',
                component: receivableManagement,
                meta: {
                    auth: ['ysfy2'],
                    title: '应收费用'
                }
            },
            {
                path: '/receivableStatement',
                name: '应收对账单',
                component: receivableStatement,
                meta: {
                    auth: ['ysdzd2'],
                    title: '应收对账单'
                }
            },
            {
                path: '/receivableStatementDetails',
                name: '应收对账单详情',
                component: receivableStatementDetails,
                hidden: true,
                meta: {
                    title: '应付对账单详情',
                    guidePath: true,
                    jumpPath: '/receivableStatement'
                }
            },
            {
                path: '/serviceStatement',
                name: '服务费账单',
                component: serviceStatement,
                meta: {
                    auth: ['fwfzd2'],
                    title: '服务费账单'
                }
            },
            {
                path: '/serviceBillDetails',
                name: '服务费账单明细',
                component: serviceBillDetails,
                hidden: true,
                meta: {
                    title: '服务费账单明细'
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-shujufenxi1',
        name: '数据统计',
        meta: {
            auth: ['sjtj1'],
            title: '数据统计'
        },
        children: [
            {
                path: '/dataAnalysis',
                name: '数据分析',
                component: analysisManage,
                meta: {
                    auth: ['sjfx2'],
                    title: '数据分析'
                }
            }

        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-chengyunshang',
        name: '车队',
        meta: {
            auth: ['cd1', 'cy2', 'cyk2'],
            title: '车队'
        },
        children: [
            {
                path: '/carrierManager',
                name: '车队管理',
                component: carrierManager,
                meta: {
                    auth: ['cdgl2'],
                    title: '车队管理'
                }
            },



        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-yunlichi',
        name: '运力池',
        meta: {
            auth: ['ylc1', 'sjgl2', 'clgl2'],
            title: '运力池'
        },
        children: [
            {
                path: '/dirverManager',
                name: '司机管理',
                component: dirverManager,
                meta: {
                    auth: ['sjgl2'],
                    title: '司机管理'
                }
            },
            {
                path: '/carManager',
                name: '车辆管理',
                component: carManager,
                meta: {
                    auth: ['clgl2'],
                    title: '车辆管理'
                }
            },

        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-peizhiguanli',
        name: '配置管理',
        meta: {
            auth: ['pzgl1', 'sjzd2', 'jzj2','fhfhtj2','cdhtj2'],
            title: '配置管理'
        },
        children: [
            {
                path: '/dictionary',
                name: '数据字典',
                component: dictionary,
                meta: {
                    auth: ['sjzd2'],
                    title: '数据字典'
                }
            },
            {
                path: '/basePriceConfig',
                name: '基准价配置',
                component: basePriceConfig,
                meta: {
                    auth:['jzj2'],
                    title: '基准价配置'
                }
            },
            {
                path: '/basePriceDetail',
                name: '查看基准价',
                hidden: true,
                component: basePriceView,
                meta: {
                    title: '查看基准价',
                    guidePath: true,
                    jumpPath: '/basePriceConfig'
                }
            },
            {
                path: '/basePriceAdd',
                name: '新增基准价',
                hidden: true,
                component: basePriceAdd,
                meta: {
                    title: '新增基准价',
                    guidePath: true,
                    jumpPath: '/basePriceConfig'
                }
            },
            {
                path: '/basePriceEdit',
                name: '编辑基准价',
                hidden: true,
                component: basePriceEdit,
                meta: {
                    title: '编辑基准价',
                    guidePath: true,
                    jumpPath: '/basePriceConfig'
                }
            },
            {
                path: '/shipperContractPriceConfig',
                name: '客户/基地合同价',
                component: shipperContractPriceConfig,
                meta: {
                    auth:['fhfhtj2'],
                    title: '客户/基地合同价'
                }
            },
            {
                path: '/shipperContractPriceView',
                name: '查看客户/基地合同价',
                hidden: true,
                component: shipperContractPriceView,
                meta: {
                    title: '查看客户/基地合同价',
                    guidePath: true,
                    jumpPath: '/shipperContractPriceConfig'
                }
            },
            {
                path: '/shipperContractPriceAdd',
                name: '新增客户/基地合同价',
                hidden: true,
                component: shipperContractPriceAdd,
                meta: {
                    title: '新增客户/基地合同价',
                    guidePath: true,
                    jumpPath: '/shipperContractPriceConfig'
                }
            },
            {
                path: '/shipperContractPriceEdit',
                name: '编辑客户/基地合同价',
                hidden: true,
                component: shipperContractPriceEdit,
                meta: {
                    title: '编辑客户/基地合同价',
                    guidePath: true,
                    jumpPath: '/shipperContractPriceConfig'
                }
            },
            {
                path: '/fleetContractPriceConfig',
                name: '车队合同价',
                component: fleetContractPriceConfig,
                meta: {
                    auth:['cdhtj2'],
                    title: '车队合同价'
                }
            },
            {
                path: '/fleetContractPriceView',
                name: '查看车队合同价',
                hidden: true,
                component: fleetContractPriceView,
                meta: {
                    title: '查看车队合同价',
                    guidePath: true,
                    jumpPath: '/fleetContractPriceConfig'
                }
            },
            {
                path: '/fleetContractPriceAdd',
                name: '新增车队合同价',
                hidden: true,
                component: fleetContractPriceAdd,
                meta: {
                    title: '新增车队合同价',
                    guidePath: true,
                    jumpPath: '/fleetContractPriceConfig'
                }
            },
            {
                path: '/fleetContractPriceEdit',
                name: '编辑车队合同价',
                hidden: true,
                component: fleetContractPriceEdit,
                meta: {
                    title: '编辑车队合同价',
                    guidePath: true,
                    jumpPath: '/fleetContractPriceConfig'
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-jichuziliao',
        name: '基础资料',
        meta: {
            auth: ['jzzl1', 'fhfgl2', 'dzb2','fhfgl2'],
            title: '基础资料'
        },
        children: [
            {
                path: '/expenseType',
                name: '费用类型维护',
                component: expenseType,
                meta: {
                    auth: ['fylxwh2'],
                    title: '费用类型维护'
                }
            },
            {
                path: '/shipManagement',
                name: '客户/基地管理',
                component: shipManagement,
                meta: {
                    auth: ['fhfgl2'],
                    title: '客户/基地管理'
                }
            },
            {
                path: '/consigneeShipperManagement',
                name: '收发货方维护',
                component: consigneeShipperManagement,
                meta: {
                    auth: ['sfhfwh22'],
                    title: '收发货方维护'
                }
            },
            {
                path: '/addressBook',
                name: '地址簿',
                component: addressBook,
                meta: {
                    auth: ['dzb2'],
                    title: '地址簿'
                }
            },
        ]
    },
    {
        path: '/',
        component: Home,
        hidden: false,
        icon: 'icon-xitongshezhi',
        name: '系统设置',
        meta: {
            auth:['xtsz1','qxgl2','bmgl2','jsgl2','yhgl2','grzx2','jzrz2'],
            title: '系统设置'
        },
        children: [
            {
                path: '/permissonSetting',
                name: '权限管理',
                component: permissonSetting,
                meta: {
                    auth:['qxgl2'],
                    title: '权限管理'
                }
            },
            {
                path: '/departManagement',
                name: '部门管理',
                component: departManagement,
                meta: {
                    auth:['bmgl2'],
                    title: '部门管理'
                }
            },
            {
                path: '/roleManagement',
                name: '角色管理',
                component: roleManagement,
                meta: {
                    auth:['jsgl2'],
                    title: '角色管理'
                }
            },
            {
                path: '/userMangement',
                name: '用户管理',
                component: userMangement,
                meta: {
                    auth:['yhgl2'],
                    title: '用户管理'
                }
            },
            {
                path: '/personal',
                name: '个人中心',
                component: personal,
                meta: {
                    auth:['grzx2'],
                    title: '个人中心'
                }
            },
            {
                path: '/crudManage',
                name: '接口日志',
                component: crudManage,
                meta: {
                    auth:['jkrz2'],
                    title: '接口日志'
                }
            }
        ]
    },
    { path: '*', redirect: { name: '401' }, hidden: true }
];

const router = new Router({
    base: '/',
    routes: constRouters,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
    // mode: 'history'
});
/**
 * 过滤路由
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.auth) {
        return roles.some(role => route.meta.auth.includes(role));
    } else {
        return true;
    }
}
/**
 * 递归查询
 */
function filterAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach(route => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });
    return res;
}


function hasRoute(routes, path) {
    if (JSON.stringify(routes).includes(path)) {
        return true;
    } else {
        return false;
    }
}
// 免登录路径
const whitelist = ['/login'];
// 避免无权限时重复生成路由
var filterRoutes = [];

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = localStorage.getItem('mlssloginAd') ? JSON.parse(localStorage.getItem('mlssloginAd')).jwtToken : null;
    // const hasToken = sessionStorage.getItem('jwtToken') ? sessionStorage.getItem('jwtToken') : localStorage.getItem('jwtToken');
    // console.log('hasToken======>', hasToken);

    if (hasToken) {
        if (to.path === '/login') {
            next()
            NProgress.done()
        } else {
            if (to.path != '/login') {
                if (!to.meta.hidden) {

                    stores.dispatch('bread/addBreadcrumb', { name: to.name, path: to.fullPath })
                }
            }
            if (filterRoutes.length == 0) {
                try {
                    var authlist = localStorage.getItem('mlssloginAd') ? JSON.parse(localStorage.getItem('mlssloginAd')).webMenus.split(",") : [];
                    // var authlist = sessionStorage.getItem("webMenus") ? sessionStorage.getItem("webMenus").split(",") : localStorage.getItem('webMenus') ? localStorage.getItem('webMenus').split(",") : [];
                    let arr = []
                    authlist.forEach(item => {
                        if (item.indexOf("\"") > -1) {
                            arr.push(item.replace("\"", "").replace("\"", ""))
                        } else {
                            arr.push(item)
                        }
                    })
                    console.log('arr' + arr)
                    filterRoutes = filterAsyncRoutes(permissonRoutes, arr);
                    router["options"].routes = [...constRouters,...filterRoutes];
                    console.log(router.options,'router.options~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
                    
                    router.addRoutes(filterRoutes);
                    next({ ...to });
                } catch (err) {
                    Message.error(err || 'Verification failed, please login again')
                    next(`/login?redirect=${to.path}`)
                    sessionStorage.clear();
                    NProgress.done()
                }
            } else {
                next()
            }
        }
    } else {
        // next()
        console.log(to.path);

        console.log(whitelist.includes(to.path));

        if (whitelist.includes(to.path)) {
            next()
        } else {
            next({ path: `/login?redirect=${to.path}`, replace: true })
            NProgress.done()
        }
    }
})

router.afterEach((to, from) => {
    NProgress.done();
});

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
    const pattern = /Loading chunk/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targetPath = (router as any).history.pending.fullPath
    if (isChunkLoadFailed && error['type'] === 'missing') {
        router.push(targetPath)
    }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router;
